import { AuthenticationProvider, UserType } from 'graphql-ts-types';

import type { RegisteredUser } from '../../registration-form/gql/types';
import { getTrackingData } from '../components/NewsletterSignupInput/utils/tracking';
import { NewsletterSignupEvent } from '../enums/Tracking';
import { Event } from '../types/auth';
import { dispatchTrackingEventGA4 } from './dispatchTrackingEventGA4';

export const trackRegisterEvent = (
  user: RegisteredUser,
  provider = AuthenticationProvider.Home24Password,
  userType = UserType.Private
) => {
  dispatchTrackingEventGA4({
    event: Event.RegistrationFormClick,
    customer_account_type: userType,
    interaction: 'Submit',
    success: 'Yes',
    provider,
    visitor_id: user.visitorId,
    visitor_hash: user.visitorHash,
    customer_type: user.type,
  });
};

export const trackRegisterError = (
  message: string,
  hasGqlErrorExtensions: boolean,
  provider = AuthenticationProvider.Home24Password,
  userType = UserType.Private
  // eslint-disable-next-line max-params
) => {
  dispatchTrackingEventGA4({
    event: Event.RegistrationFormClick,
    customer_account_type: userType,
    interaction: 'Submit',
    success: 'No',
    provider,
    name: hasGqlErrorExtensions ? 'validationError' : 'serverError',
    message,
  });
};

export const trackNewsLetterSignUpSuccessEvent = ({ visitorHash }: RegisteredUser) => {
  dispatchTrackingEventGA4(
    getTrackingData({
      event: NewsletterSignupEvent.NewsLetterSignUpSuccess,
      tracking: {
        placement: '',
        visitorHash,
      },
    })
  );
};
